'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.controller('commonCtrl', function ($scope, $ionicModal) {
    var modals = {};
    var templates = {
      0: require('./modal0.html'),
      1: require('./modal1.html'),
      2: require('./modal2.html'),
      3: require('./modal3.html'),
      4: require('./modal4.html')
    };
    $scope.showModal = function (key) {
      if (!modals[key]) {
        modals[key] = $ionicModal.fromTemplate(templates[key], { scope: $scope });
      }
      modals[key].show();
    };
    $scope.hideModal = function (key) {
      if (modals[key]) {
        modals[key].hide();
      }
    };
  });
  return app;
};

; /**
   * common
   */


//////////////////
// WEBPACK FOOTER
// ./src/pages/common/index.ctrl.js
// module id = 45
// module chunks = 0